// extracted by mini-css-extract-plugin
var _1 = "ChooseMany_checked__smJMD";
var _2 = "ChooseMany_chooseManyContainer__Bcr8J";
var _3 = "768px";
var _4 = "'../../../shared.module.css'";
export { _1 as "checked", _2 as "chooseManyContainer", _3 as "md", _4 as "shared" }
